import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { LocalStorageService } from '../../shared/services/local-storage.service';

@Directive({
  selector: '[hasRole]',
  standalone: true,
})
export class HasRoleDirective {

  @Input() set hasRole(allowedRoles: string[]) {
    const role = this.localStorage.getRole();

    if (!role) {
      //TODO: display loading state or placeholder
      this.viewContainer.clear();
      return;
    }

    if (allowedRoles.includes(role)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private localStorage: LocalStorageService,
  ) {}
}
